import constants from './constants';

const initState = {
  createNewBusinessType: {
    id: '',
    name: '',
    description: '',
    latitude: '',
    longitude: '',
    type: '',
  },
  businessTypeIdToEdit: null,
};

function businessTypeReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_CREATE_EDIT_BUSINESSTYPE:
      return {
        ...state,
        createNewBusinessType: payload,
      };

    case constants.SET_BUSINESSTYPE_ID_TO_EDIT:
      return {
        ...state,
        businessTypeIdToEdit: payload,
      };

    default:
      return state;

  }

}

export default businessTypeReducer;
